/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitializePasswordEmailResult
 */
export interface InitializePasswordEmailResult {
    /**
     * 
     * @type {string}
     * @memberof InitializePasswordEmailResult
     */
    emailKind: InitializePasswordEmailResultEmailKindEnum;
}


/**
 * @export
 */
export const InitializePasswordEmailResultEmailKindEnum = {
    InitialPasswordEmailSent: 'initialPasswordEmailSent',
    PasswordResetEmailSent: 'passwordResetEmailSent',
    SyncedExistingEmailPasswordAndReset: 'syncedExistingEmailPasswordAndReset'
} as const;
export type InitializePasswordEmailResultEmailKindEnum = typeof InitializePasswordEmailResultEmailKindEnum[keyof typeof InitializePasswordEmailResultEmailKindEnum];


/**
 * Check if a given object implements the InitializePasswordEmailResult interface.
 */
export function instanceOfInitializePasswordEmailResult(value: object): value is InitializePasswordEmailResult {
    if (!('emailKind' in value) || value['emailKind'] === undefined) return false;
    return true;
}

export function InitializePasswordEmailResultFromJSON(json: any): InitializePasswordEmailResult {
    return InitializePasswordEmailResultFromJSONTyped(json, false);
}

export function InitializePasswordEmailResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitializePasswordEmailResult {
    if (json == null) {
        return json;
    }
    return {
        
        'emailKind': json['emailKind'],
    };
}

export function InitializePasswordEmailResultToJSON(json: any): InitializePasswordEmailResult {
    return InitializePasswordEmailResultToJSONTyped(json, false);
}

export function InitializePasswordEmailResultToJSONTyped(value?: InitializePasswordEmailResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailKind': value['emailKind'],
    };
}

